module.exports = __webpack_public_path__ + "static/fonts/DIN-Medium.1bbe346.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/DIN-Medium.otf
// module id = a9LG
// module chunks = 1